enum Deliverability {
  new = "new",
  delivered = "delivered",
  received = "received",
  validated = "validated",
  sent = "sent",
  buffered = "buffered",
  queued = "queued",
  expired = "expired",
  error = "error",
  invalid = "invalid",
  delivery_failed = "delivery_failed",
  scheduled = "scheduled",
  na = "n/a",
}

export const deliverabilityAsString = (
  deliverability: Deliverability
): string => {
  switch (deliverability) {
    case Deliverability.new:
      return "Nouveau";
    case Deliverability.delivered:
      return "Délivré";
    case Deliverability.received:
      return "Reçu";
    case Deliverability.validated:
      return "Validé";
    case Deliverability.sent:
      return "Envoyé";
    case Deliverability.buffered:
      return "Mis en tampon";
    case Deliverability.queued:
      return "En attente";
    case Deliverability.expired:
      return "Expiré";
    case Deliverability.error:
      return "Erreur";
    case Deliverability.invalid:
      return "Invalide";
    case Deliverability.delivery_failed:
      return "Échec de livraison";
    case Deliverability.scheduled:
      return "Planifié";
    case Deliverability.na:
      return "N/A";
    default:
      return "";
  }
};

export default Deliverability;
